export enum PaymentMethodEnum {
  card = "CR",
  paynow = "PN",
}
